import { io, type Socket } from 'socket.io-client'

/**
 * Same connection pattern as kei.bio's own src/composables/useSocket.js
 * (`io(apiUrl, { path: '/socket.io', withCredentials: true })`) — MEET
 * connects to the SAME socket.io server on api.kei.bio (cross-subdomain
 * `kei_token` cookie auth, `.kei.bio` domain), not a separate signaling
 * server. `meet.kei.bio` was added to that server's CORS allowlist
 * (server/index.js and server/lib/socket.js) the same way `call.kei.bio` was.
 */
const API_URL = (import.meta.env.VITE_API_URL as string | undefined) || 'https://api.kei.bio'

let socket: Socket | null = null

export function connectSocket(): Socket {
  if (socket) return socket
  socket = io(API_URL, { path: '/socket.io', withCredentials: true })
  return socket
}

export function getSocket(): Socket | null {
  return socket
}

export function disconnectSocket() {
  socket?.disconnect()
  socket = null
}
